import ButtonLink from 'components/common/ButtonLink';
import { FormattedMessage } from 'react-intl';
import requireValue from 'utils/requireValue';

interface ISwitcherProps {
  isSignUp?: boolean;
  /** Passed where sign-up is enabled (the sign-up page); without it a click throws. */
  setIsSignUp?: (isSignUp: boolean) => void;
}

export default function Switcher({ isSignUp, setIsSignUp }: ISwitcherProps) {
  return isSignUp ? (
    <p style={{ marginTop: '25px' }}>
      <FormattedMessage id="auth.already_have_account" />{' '}
      <ButtonLink onClick={() => requireValue(setIsSignUp, 'call')(false)}>
        <FormattedMessage id="auth.already_have_account_sign_in_link" />
      </ButtonLink>
    </p>
  ) : (
    <p>
      <FormattedMessage id="auth.dont_have_account" />{' '}
      <ButtonLink onClick={() => requireValue(setIsSignUp, 'call')(true)}>
        <FormattedMessage id="auth.dont_have_account_sign_up_link" />
      </ButtonLink>
    </p>
  );
}
